// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPeopleFullBody = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.75 4.75a2.75 2.75 0 1 1-5.5 0 2.75 2.75 0 0 1 5.5 0zM12 3.65a1.1 1.1 0 1 0 0 2.2 1.1 1.1 0 0 0 0-2.2z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.857 8.342c.466.088.716.125 1.143.125.428 0 .687-.037 1.152-.125l5.758-1.08a1.25 1.25 0 0 1 1.459 1l.368 1.965a1.25 1.25 0 0 1-.993 1.458l-3.707.734 1.202 8.476.002.013A1.25 1.25 0 0 1 16 22.312h-2.298a1.25 1.25 0 0 1-1.21-.938l-.003-.01-.487-2.001-.484 2-.003.01a1.25 1.25 0 0 1-1.21.938H8a1.25 1.25 0 0 1-1.24-1.403l.001-.013 1.202-8.476-3.698-.734a1.25 1.25 0 0 1-.993-1.458L3.64 8.26a1.25 1.25 0 0 1 1.46-.998zm-1.21 2.882-1.359 9.588h1.82l1.163-4.804 1.458-.001 1.17 4.804h1.813l-1.36-9.587 4.865-.964-.276-1.477-5.513 1.034c-.51.095-.87.15-1.428.15-.56 0-.911-.055-1.42-.15L5.069 8.783l-.276 1.477z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPeopleFullBody;
